import * as React from 'react'
import SanityBlock from 'components/common/SanityBlock'
import CTALink from 'components/common/CTALink'

const HeroText = ({ title, description, link }) => (
	<div className="richtext">
		{title && <h2 className="technical-lg">{title}</h2>}
		<SanityBlock body={description} className="richtext sm" />
		<CTALink {...link} />
	</div>
)

export default HeroText
